import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, Button, Checkbox, FormControlLabel, FormGroup, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PaletaColor } from "../../../../styles/StylesConstantes";
import { CssTextField } from "../../../../styles/styles";
import { BrokenImage } from "@mui/icons-material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers";
import { optionMonedas, optionMotivosRechazos } from "../../../../constantes/constantes";

function EditarCuponComponents({
    nombreUsuario,
    documentoCliente,
    setDocumentoCliente,
    nroFactura,
    setNroFactura,
    nrotimbrado,
    setNroTimbrado,
    monto,
    setMonto,
    imagen,
    fecha,
    handleFechaSelected,
    rechazar,
    setRechazar,
    locales,
    localSelected,
    handleLocalSelected,
    handleLocalSearch,
    monedasSelected,
    handleMonedasSearch,
    handleMonedasSelected,
    motivoRechazoSelected,
    handleMotivoRechazoSearch,
    handleMotivoRechazoSelected,
    observacionAdicional,
    setObservacionAdicional,
    handleGuardar
}) {
    const [errorImagen, setErrorImagen] = useState(false);
    const [scale, setScale] = useState(1);
    const [isDragging, setIsDragging] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [startDrag, setStartDrag] = useState({ x: 0, y: 0 });
    const [imageSize, setImageSize] = useState({ width: 0, height: 0 });

    const history = useNavigate();
    const imageWrapperRef = useRef(null);

    useEffect(() => {
        const node = imageWrapperRef.current;
        if (!node) return;

        const handleWheelZoom = (e) => {
            e.preventDefault();
            let newScale = scale + (e.deltaY < 0 ? 0.1 : -0.1);
            newScale = Math.max(1, Math.min(newScale, 3));
            setScale(newScale);
        };

        node.addEventListener("wheel", handleWheelZoom, { passive: false });
        return () => {
            node.removeEventListener("wheel", handleWheelZoom);
        };
    }, [scale]);

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartDrag({ x: e.clientX - position.x, y: e.clientY - position.y });
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        setPosition({
            x: e.clientX - startDrag.x,
            y: e.clientY - startDrag.y
        });
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseLeave = () => {
        setIsDragging(false);
    };

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                <div className="bg-white rounded-xl border border-gray-200 p-5">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="md:col-span-2">
                            <Typography variant="subtitle2" className="mb-2 text-gray-700">Usuario</Typography>
                            <CssTextField
                                value={nombreUsuario}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                autoCapitalize="none"
                                autoCorrect={"false"}
                                disabled={true}
                                style={{ marginTop: 0 }}
                            />
                        </div>

                        <div>
                            <Typography variant="subtitle2" className="mb-2 text-gray-700">Documento Cliente Factura</Typography>
                            <CssTextField
                                value={documentoCliente}
                                onChange={(e) => setDocumentoCliente(e.target.value)}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                autoCapitalize="none"
                                autoCorrect={"false"}
                                style={{ marginTop: 0 }}
                            />
                        </div>

                        <div>
                            <Typography variant="subtitle2" className="mb-2 text-gray-700">Local</Typography>
                            <Autocomplete
                                disablePortal
                                options={locales}
                                sx={{ width: "100%" }}
                                renderInput={(params) => <TextField {...params} label="Seleccione" />}
                                onChange={(a, b) => {
                                    handleLocalSelected(b);
                                }}
                                onInputChange={(event, newInputValue) => {
                                    handleLocalSearch(newInputValue);
                                }}
                                value={localSelected || null}
                                getOptionLabel={(option) => option?.nombre_fantasia || ""}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                getOptionKey={(option) => option.id}
                                loadingText={"Cargando..."}
                                noOptionsText={"No hay opciones"}
                            />
                        </div>

                        <div>
                            <Typography variant="subtitle2" className="mb-2 text-gray-700">Nro. de Factura</Typography>
                            <CssTextField
                                value={nroFactura}
                                onChange={(e) => setNroFactura(e.target.value)}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                autoCapitalize="none"
                                autoCorrect={"false"}
                                style={{ marginTop: 0 }}
                            />
                        </div>

                        <div>
                            <Typography variant="subtitle2" className="mb-2 text-gray-700">Timbrado</Typography>
                            <CssTextField
                                value={nrotimbrado}
                                onChange={(e) => setNroTimbrado(e.target.value)}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                autoCapitalize="none"
                                autoCorrect={"false"}
                                style={{ marginTop: 0 }}
                            />
                        </div>

                        <div>
                            <Typography variant="subtitle2" className="mb-2 text-gray-700">Monto</Typography>
                            <CssTextField
                                value={monto.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/[^0-9]/g, "");
                                    setMonto(value);
                                }}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                autoCapitalize="none"
                                autoCorrect={"false"}
                                style={{ marginTop: 0 }}
                            />
                        </div>

                        <div>
                            <Typography variant="subtitle2" className="mb-2 text-gray-700">Moneda</Typography>
                            <Autocomplete
                                disablePortal
                                options={optionMonedas}
                                sx={{ width: "100%" }}
                                renderInput={(params) => <TextField {...params} label="Seleccione" />}
                                onChange={(a, b) => {
                                    handleMonedasSelected(b);
                                }}
                                onInputChange={(event, newInputValue) => {
                                    handleMonedasSearch(newInputValue);
                                }}
                                value={monedasSelected || null}
                                getOptionLabel={(option) => option?.label || ""}
                                getOptionKey={(option) => option.id}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                loadingText={"Cargando..."}
                                noOptionsText={"No hay opciones"}
                            />
                        </div>

                        <div>
                            <Typography variant="subtitle2" className="mb-2 text-gray-700">Fecha</Typography>
                            <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    value={fecha}
                                    format="DD/MM/YYYY"
                                    ampm={false}
                                    onChange={(newValue) => {
                                        handleFechaSelected(newValue);
                                    }}
                                    sx={{ width: "100%" }}
                                />
                            </LocalizationProvider>
                        </div>

                        <div className="md:col-span-2">
                            <Typography variant="subtitle2" className="mb-2 text-gray-700">Rechazar</Typography>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={rechazar}
                                            onChange={(e) => setRechazar(e.target.checked)}
                                        />
                                    }
                                    label=""
                                />
                            </FormGroup>
                        </div>

                        {rechazar && (
                            <div className="md:col-span-2">
                                <Typography variant="subtitle2" className="mb-2 text-gray-700">Motivo del rechazo</Typography>
                                <Autocomplete
                                    disablePortal
                                    options={optionMotivosRechazos}
                                    sx={{ width: "100%" }}
                                    renderInput={(params) => <TextField {...params} label="Seleccione" />}
                                    onChange={(a, b) => {
                                        handleMotivoRechazoSelected(b);
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        handleMotivoRechazoSearch(newInputValue);
                                    }}
                                    value={motivoRechazoSelected || null}
                                    getOptionLabel={(option) => option?.label || ""}
                                    getOptionKey={(option) => option.id}
                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                    loadingText={"Cargando..."}
                                    noOptionsText={"No hay opciones"}
                                />
                            </div>
                        )}

                        {(motivoRechazoSelected?.label === "Otros" && rechazar) && (
                            <div className="md:col-span-2">
                                <Typography variant="subtitle2" className="mb-2 text-gray-700">Observacion adicional</Typography>
                                <CssTextField
                                    value={observacionAdicional}
                                    onChange={(e) => {
                                        setObservacionAdicional(e.target.value);
                                    }}
                                    variant="outlined"
                                    margin="normal"
                                    multiline
                                    rows={4}
                                    fullWidth
                                    autoCapitalize="none"
                                    autoCorrect={"false"}
                                    style={{ marginTop: 0 }}
                                />
                            </div>
                        )}
                    </div>

                    <div className="flex flex-wrap items-center gap-4 pt-6 mt-6 border-t border-gray-200">
                        <Button
                            variant="contained"
                            onClick={() => handleGuardar()}
                            sx={{
                                backgroundColor: "#104063",
                                color: "#ffffff",
                                fontWeight: 700,
                                textTransform: "none",
                                borderRadius: "10px",
                                px: 3,
                                py: 1,
                                "&:hover": {
                                    backgroundColor: "#0d3553",
                                },
                            }}
                        >
                            Guardar
                        </Button>

                        <Button
                            variant="outlined"
                            onClick={() => history(-1)}
                            sx={{
                                borderColor: "#d1d5db",
                                color: "#374151",
                                fontWeight: 600,
                                textTransform: "none",
                                borderRadius: "10px",
                                px: 3,
                                py: 1,
                                "&:hover": {
                                    borderColor: "#9ca3af",
                                    backgroundColor: "#f3f4f6",
                                },
                            }}
                        >
                            Cancelar
                        </Button>
                    </div>
                </div>

                <div className="bg-white rounded-xl border border-gray-200 p-5">
                    {imageSize.width > 0 && (
                        <Typography variant="caption" color={PaletaColor.ROJO}>
                            Hacer zoom en la imagen con la rueda del mouse o el panel tactil.
                        </Typography>
                    )}

                    {imagen ? (
                        <div
                            ref={imageWrapperRef}
                            style={{
                                width: "100%",
                                height: 500,
                                borderRadius: 16,
                                overflow: "hidden",
                                position: "relative",
                                border: `1px solid ${PaletaColor.COLOR_BACKGROUND_GRIS_CLARO}`,
                                backgroundColor: PaletaColor.COLOR_BACKGROUND_GRIS_CLARO,
                                marginTop: 8,
                            }}
                            onMouseDown={handleMouseDown}
                            onMouseMove={handleMouseMove}
                            onMouseUp={handleMouseUp}
                            onMouseLeave={handleMouseLeave}
                        >
                            {!errorImagen && (
                                <img
                                    src={imagen}
                                    alt="imagen"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain",
                                        display: "block",
                                        transform: `scale(${scale}) translate(${position.x / scale}px, ${position.y / scale}px)`,
                                        cursor: isDragging ? "grabbing" : "grab",
                                        transition: isDragging ? "none" : "transform 0.2s ease",
                                        userSelect: "none",
                                    }}
                                    draggable={false}
                                    onLoad={(e) => {
                                        const img = e.target;
                                        setImageSize({
                                            width: img.naturalWidth,
                                            height: img.naturalHeight
                                        });
                                    }}
                                    onError={(e) => {
                                        console.log("error", e);
                                        setErrorImagen(true);
                                    }}
                                />
                            )}

                            {errorImagen && (
                                <div
                                    style={{
                                        width: "100%",
                                        height: 500,
                                        borderRadius: 16,
                                        backgroundColor: PaletaColor.COLOR_BACKGROUND_GRIS_CLARO,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <BrokenImage style={{ fontSize: 100, color: PaletaColor.COLOR_BACKGROUND_GRIS }} />
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="mt-2 w-full h-[500px] rounded-2xl border border-gray-200 bg-gray-50 flex items-center justify-center text-gray-500 text-sm">
                            Sin imagen
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default EditarCuponComponents;
